import { proxy, subscribe } from "valtio";
import { SiteFiltersStore, SiteFiltersStoreSchema, defaultValues, resetSiteFiltersStore } from "./store";
import { subscribeKey } from "valtio/utils";
import { siteStore } from "src/js/stores/site/store";

const LOCAL_STORAGE_KEY = "siteFiltersMapStore";

let previousProjectId = siteStore.selectedProjectId;

function loadFiltersFromLocalStorageSafely(): SiteFiltersStore {
  try {
    const persistedFilters = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)!);

    if (!persistedFilters) {
      return { ...defaultValues };
    }

    return SiteFiltersStoreSchema.parse(persistedFilters);
  } catch (error) {
    console.error("Error loading persisted filters:", error);
    return { ...defaultValues };
  }
}

export const siteFiltersMapStore = proxy<SiteFiltersStore>(loadFiltersFromLocalStorageSafely());

// when the store changes, persist the filters to local storage
subscribe(siteFiltersMapStore, function syncStoreToLocalStorage() {
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(siteFiltersMapStore));
});

// when the selected workspace changes, reset the saved sites filters
subscribeKey(siteStore, "selectedProjectId", (newProjectId) => {
  if (previousProjectId !== null && newProjectId !== previousProjectId) {
    resetSiteFiltersStore(siteFiltersMapStore);
  }
  previousProjectId = newProjectId;
});
